'use client';

import { toast as toastFn, ToastBar, Toaster } from 'react-hot-toast';
import { useMediaQuery } from './use-media-query';

export function CommonToaster() {
  const sm = useMediaQuery(640);

  return (
    <Toaster
      containerStyle={{
        zIndex: 2147483647,
      }}
      toastOptions={{
        duration: 7500,
        style: {
          zIndex: 2147483647,
          fontSize: sm ? '1.5rem' : undefined,
          lineHeight: sm ? '2rem' : undefined,
        },
      }}
    >
      {(toast) => (
        <ToastBar toast={toast}>
          {({ icon, message }) => (
            <div className="flex items-center gap-2" onClick={() => toastFn.dismiss(toast.id)}>
              {icon}
              {message}
            </div>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}
